<template>
  <v-data-table
    id="hmd_table_element"
    fixed-header
    :headers="headers"
    :items="data.rows"
  >
    <template v-slot:items="props">
      <td
        v-for="(el, el_index) in headers"
        :key="props.index+''+el_index"
        :class="el.align?('text-xs-'+el.align):''"
      >
        {{ props.item[el.value] }}
      </td>
    </template>
  </v-data-table>
</template>

<script>
  import {
    VIZ_CONFIGS,
  } from './../constants/VisualizationConfigs'

  import HELPER from './../../../Dashboard/Views/Projects/Dashboards/helpers/helper'
  export default {
    mixins: [HELPER],
    props: {
      fillParent: {
        required: false,
        type: Boolean,
        default: () => { return false },
      },
      data: {
        required: true,
        type: Object,
        default: () => {
          return {
            columns: [],
            rows: [],
          }
        },
      },
      options: {
        required: false,
        type: Object,
        default: () => {
          return VIZ_CONFIGS['table']
        },
      },
    },
    data () {
      return {
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 5,
          sortBy: '',
          totalItems: this.data.rows.length,
        },
      }
    },
    computed: {
      headers () {
        let headers = []
        if (this.data.columns.length <= 0 || this._.isEmpty(this.options)) { return [] }
        if (this._.isEmpty(this.options['Columns']['Column Parameters']['columns'])) { return [] }
        let columns = this.getHeader(this.data.columns)
        this._.map(columns, (col, colName) => {
          if (this.options['Columns']['Column Parameters']['columns'][colName]) { col = this.options['Columns']['Column Parameters']['columns'][colName] }
          let label = col.label
          let visible = col.visible
          if (visible) {
            headers.push({
              text: label,
              sortable: false,
              value: colName,
              align: col.align,
            })
          }
        })
        return headers
      },
    },
    watch: {
      options: {
        deep: true,
        handler (newValue) {
          if (newValue.Grid) {
            if (newValue.Grid['Items per page'].value <= this.data.rows.length) { this.pagination.rowsPerPage = newValue.Grid['Items per page'].value }
          }
        },
      },
    },
    methods: {
      /* reEvaluateOptionColumns(){
                let data_cols = this.getHeader(this.data.columns)
                let element_cols = this.options['Columns']['Column Parameters']['columns']

            } */
    },
  }
</script>

<style>
#hmd_table_element {
  height:100% !important;
}
#hmd_table_element > .v-data-table__wrapper{
  height: calc(100% - 60px) !important;
}
</style>
